import mixpanel from 'mixpanel-browser'

export abstract class BaseMixpanelTracker {
  constructor(
    private readonly projectToken: string,
    private config?: Parameters<typeof mixpanel.init>[1],
  ) {}

  initialize() {
    mixpanel.init(this.projectToken, this.config)
  }

  // abstract identify(uniqueId: string, ...rest): void
  abstract behaviorTrack(eventName: string, eventProps?: Record<string, any>): void
  abstract uiTrack(eventName: string, eventProps?: Record<string, any>): void

  abstract apiTrack(response: unknown): void
  abstract errorTrack(response: unknown): void

  abstract strapiTrack(response: unknown): void
  abstract strapiErrorTrack(response: unknown): void

  abstract printApiTrack(response: unknown): void
  abstract printErrorTrack(response: unknown): void
}
